import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  simpleCard: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    backgroundColor: '#F7F7F7',
    textAlign: 'left',
    fontSize: 20,
    lineHeight: 1.5,
    padding: '16px 16px',
    borderRadius: '20px',
  
    marginBottom: '16px',
    [theme.breakpoints.up('md')]: {
      fontSize: 20,
      padding: '32px 24px',
    },
  },
  simpleCardTitleTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  simpleCardTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  simpleCardTitleImage: {
    marginTop: '4px',
    marginRight: '16px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
  simpleCardTitleText: {
    fontSize: 18,
    [theme.breakpoints.up('md')]: {
      fontSize: 20,
    },
  },
}));
